<template>
      <v-card max-width="500" class="padd">
         <div class="text-center">
          <v-container>
               <v-card-title>
              <b><span class="headline">Confirm</span></b>
            </v-card-title>
                <hr/>
              <v-row>
                  <v-col cols="12" sm="4">
                 <p><b>Customer Phone</b></p>
                </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{phoneNumber}}</p>
                </v-col>
                 <v-col cols="12" sm="4">
                 <p><b>Service Name</b></p>
                </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{CableItems.serviceName}}</p>
                </v-col>
                  <v-col cols="12" sm="4">
                 <p><b>Amount</b></p>
                </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{DisplayCurrency(CableItems.amount/100)}}</p>
                </v-col>
                   <v-col cols="12" sm="4">
                 <p><b>Fees Amount</b></p>
                </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{DisplayCurrency(CableItems.feesAmount/100)}}</p>
                </v-col>
                   <v-col cols="12" sm="4">
                 <p><b>Total Amount</b></p>
                </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{DisplayCurrency(CableItems.amount/100)}}</p>
                </v-col>
              </v-row>
      </v-container>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text large @click="close">close</v-btn>
          <v-btn dark class="btn" large @click="InternetPayment()">Send</v-btn>
        <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
</template>

<script>
import currencyFormatter from 'currency-formatter'

  export default {
    props:['serviceCode', 'phoneNumber', 'network'],
    data () {
      return {dialog: false}
    },
  methods: {
      close(){
          this.$store.commit('setInternetDialog', false)
      },
      InternetPayment(){
         let payload = {
                    customerID:this.User.customerID,
                    pin:this.User.pin,
                    network:this.network,
                    serviceCode:this.serviceCode,
                    CableItems:this.CableItems,
                    phoneNumber:this.phoneNumber,
                    amount:this.amount,
                    route: this.$router
                    }
                    this.$store.dispatch('InternetPayment', payload)
      },
       DisplayCurrency(payload) {
      return currencyFormatter.format(payload, {
        code: "NGN"
      });
       },
     },
  computed: {
        CableItems(){
         return this.$store.getters.getInternetItems
        },
         User () {
        return this.$store.getters.getUser
        },
    },
  }
</script>
<style scoped>
.cardTr{
    display: flex;
    align-items: center;
    padding: 15px;
    padding-right: 20px;
    padding-left: 20px;
    height: 100px;
    border-radius: 20px !important;
    margin-right: 20px;
    margin-left: 20px;
    cursor: pointer;
}
.bg{
    background-color: rgba(235, 87, 87, 0.2);
}
.init{
    margin-left: 15px;
}
.padd{
    padding: 10px;
    border-radius: 10px;
}
.bankT{
    text-align: center;
    color: #ad1684;

}
.btn{
    background-color: #ad1684 !important;
    text-transform: none;
}
.nextBtn{
     background-color: #AD1684 !important;
     border-radius: 10px;
     text-transform: none;
}
</style>